import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ActivityTabs, ComponentTypes, DEFAULT_LANGUAGE_ID } from 'src/app/shared/constants/commonenums';
import { FieldConfig } from 'src/app/shared/dynamicform/models/common-models';
import { ComponentDetails } from 'src/app/shared/dynamicform/models/popup.interface';
import { Language, LanguageFileName } from 'src/app/shared/Models/WidgetSettingsModels';
import { GuestService } from 'src/app/shared/services/guest.service';
import { LocalizeService } from 'src/app/shared/services/localize.service';
import { PopupService } from 'src/app/shared/services/popup.service';
import { Utilities } from 'src/app/shared/utilities/utilities';
import { ActivitiesService } from '../../activities.service';
import { LayoutService } from 'src/app/layout/layout.service';
import moment from 'moment';


@Component({
    selector: 'app-activity-common-header',
    templateUrl: './activity-common-header.component.html',
    styleUrls: ['./activity-common-header.component.scss'],
    standalone: false
})
export class ActivityCommonHeaderComponent extends Utilities implements OnInit, OnDestroy {
  @Input() propertyName;
  @Output() headerData = new EventEmitter<object>();
  propertyLocation: string;
  propertyInfo: any;
  subscriptions: Subscription = new Subscription();
  SelectedLanguage: any;
  languageConfig: FieldConfig[];
  languageOptions = [];
  isCartEnabled: boolean;
  initialLanguageChange = true;
  constructor(private translateService: TranslateService, public activityService: GuestService, public dialog: MatDialog,
    public ps: PopupService, private localizeService: LocalizeService, private route: ActivatedRoute,private ls: LayoutService, private router: Router) {
    super(dialog);
    this.subscriptions.add(this.activityService.CartBookingList$.subscribe(data => {
      const CartList = JSON.parse(sessionStorage.getItem('CartList'));
      this.activityService.cartCount = CartList.length;
    }));
    this.subscriptions.add(this.activityService.restaurantWidgetSettings$.subscribe(value => {
      if (value) {
        this.propertyInfo = value;
        this.isCartEnabled = value.IsCartEnabled;
        this.getPropLocation(this.propertyInfo);
      }
    }))
  }

  ngOnInit(): void {
    this.generateLanguageOptions();
    this.SelectedLanguage = this.languageOptions[0].id
    this.languageConfig = [
      {
        type: 'select',
        name: 'sortBy',
        placeholder: '',
        options: this.languageOptions,
        value: this.activityService.selectedLanguageId ? this.activityService.selectedLanguageId : this.languageOptions[0].id,
        showErrorText: true,
        isTranslate: true,
        appearance: false,
        cellClick: this.setDefaultLanguage.bind(this),
        class: 'header__language',
        isFormArray: false
      }
    ];
    const url = new URL(window.location.href);
    let language = this.route.snapshot.params['language'] || url.searchParams.get('language');
    if(language){
      language = language.toLowerCase();
      this.activityService.selectedLanguageId = Number(LanguageFileName[language]);
      this.languageConfig[0].value = this.activityService.selectedLanguageId;
      this.languageConfig = [...this.languageConfig];
      this.setLanguage({ value: this.activityService.selectedLanguageId }, language);
    }
    if(!language){
      const url = new URL(window.location.href);
      language = this.route.snapshot.queryParams['language'];  
      this.languageConfig[0].value = language ? language.toLowerCase() : sessionStorage.getItem('languageId')? Number(sessionStorage.getItem('languageId')) :LanguageFileName.english;
      this.setLanguage({value: sessionStorage.getItem('languageId') ? Number(sessionStorage.getItem('languageId')) : this.languageOptions[0].id},language)
    }
  }

  setDefaultLanguage(event){
    if(this.initialLanguageChange){
      sessionStorage.setItem('languageId',event.value)
      this.activityService.selectedLanguageId = Number(event.value);
      this.activityService.loadLanguageData(true);
      this.initialLanguageChange = false;
    }
    this.setLanguage(event)
  }
  /* setting language on change of drop down */
  setLanguage(event,language?) {
   // moment.locale(this.activityService.availableLanguages.find(lang => lang.Id == event.value)?.Code)
   if(language && this.activityService.availableLanguages){
    event.value = this.activityService.availableLanguages.find(lng => lng.Name.toLowerCase() == language)?.Id || DEFAULT_LANGUAGE_ID
  }
   this.activityService.selectedLanguageId = event.value;
    sessionStorage.setItem('languageId',event.value)
    let selectedLanguage=LanguageFileName[event.value];
      this.localizeService.setLanguage(selectedLanguage, this.activityService.restaurantWidgetSettings$.value.PropertyType.toLowerCase(), this.activityService.restaurantWidgetSettings$.value.RestaurantUniqueName);
      this.activityService.languageFileChanges.next(selectedLanguage);
    }

  generateLanguageOptions() {
    // Object.keys(Language).map(x => {
    //   if (!isNaN(Number(x))) {
    //     this.languageOptions.push({ id: Number(x), value: Language[Number(x)] })
    //   }
    // });
    this.activityService.restaurantWidgetSettings$.subscribe((data : any) => {
      if(data.Languages?.length)
      this.activityService.availableLanguages = data.Languages;
        this.languageOptions  = data.Languages.map(language =>  { return { id: language.Id , value: language.DisplayName}});
      this.languageConfig[0].options = this.languageOptions;
      this.languageConfig[0].value = this.languageOptions[0].id;
    })
  }

  getPropLocation(propertyInfo) {
    if (propertyInfo) {
      let headerValue = '';
      if (propertyInfo.Street1) {
        headerValue = headerValue + propertyInfo.Street1;
      }
      if (propertyInfo.Street2) {
        headerValue = headerValue + ', ' + propertyInfo.Street2;
      }
      if (propertyInfo.City) {
        headerValue = headerValue + ', ' + propertyInfo.City;
      }
      if (propertyInfo.State) {
        headerValue = headerValue + ', ' + propertyInfo.State;
      }
      if (propertyInfo.Country) {
        headerValue = headerValue + ', ' + propertyInfo.Country;
      }
      this.propertyLocation = headerValue;

    }
  }
  ngOnDestroy(): void {
    if (this.subscriptions) { this.subscriptions.unsubscribe(); }
  }

  showCartItems() {
    this.activityService.TabChange$.next(ActivityTabs.CartDetails); 
  }
}
